module.exports = __webpack_public_path__ + "img/story-bg.db5c57cd.jpeg";